import {Command, EditorState} from "prosemirror-state";
import {setBlockType} from "prosemirror-commands";

import {schema} from "../../config/schema";
import {isBlockActive} from "../../../utils/isBlockActive";

import {setBlockTypeParagraph} from "./paragraph";

export const setBlockTypeHeading = (level: number): Command =>
    setBlockType(schema.nodes.heading, { level });


export const toggleBlockTypeHeading = (level: number): Command => {
    const setNodeToHeading = setBlockTypeHeading(level);
    const isNodeHeadingLevel = isBlockActive(schema.nodes.heading, { level });

    return (state: EditorState, dispatch) => {
        const parentNode = state.selection.$from.node(-1);
        if (parentNode.type !== schema.nodes.doc) {
            return false;
        }
        if (isNodeHeadingLevel(state)) {
            return setBlockTypeParagraph(state, dispatch);
        } else {
            return setNodeToHeading(state, dispatch);
        }
    }
}

export const canToggleBlockTypeHeading = (level: number): Command => {
    const command = toggleBlockTypeHeading(level);
    return (state: EditorState) => {
        return command(state);
    }
}
